import React, { useState, useEffect, useRef, useCallback } from "react";
import LikeButton from "./LikeButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComment, faShare, faTrash } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import ImageModal from './ImageModal';
import ShareModal from "./ShareModal";
import { IoSend } from "react-icons/io5";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import styled from "styled-components";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import LikeCommentModal from "./LikeCommentModal";

const Container = styled.div`
  width: 425px;
  margin: 6px;
  border-radius: 20px;
  background: #F1F1F1;
  ${'' /* box-shadow: 9px 9px 16px #a3b1c6, -9px -9px 16px #ffffff; */}
  box-shadow: 3px 3px 4px #a3b1c6, -5px -5px 15px #ffffff;
  padding: 20px;
  box-sizing: border-box;
  position: relative;

  @media (max-width: 767px) {
    width: calc(100% - 12px);
    padding: 16px;
  }
`;

const Header = styled.div`
  display: flex;
  align-items : center;
  margin-bottom: 16px;
`;

const ProfileImage = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 12px;
  background: #F1F1F1;
  box-shadow: inset 4px 4px 8px #a3b1c6, inset -4px -4px 8px #ffffff;

  @media (max-width: 767px) {
    width: 40px;
    height: 40px;
    margin-right: 8px;
  }
`;

const CategoryLabel = styled.div`
  position: absolute;
  top: 20px;
  right: 50px;
  background-color: #e75b82;
  color: white;
  padding: 5px 10px;
  border-radius: 12px;
  font-size: 12px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);

  @media (max-width: 767px) {
    right : 40px;
    font-size: 10px;
  }

  @media (max-width: 374px) {
    right : 25px;
    font-size: 6px;
  }
`;

const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const UserName = styled.span`
  font-size: 16px;
  font-weight: bold;
  margin: 0;
  color: #333;

  @media (max-width: 424px) {
    font-size: 12px;
  }
`;

const PostTime = styled.span`
  font-size: 12px;
  color: #999;
  margin: 0;
`;

const Content = styled.div`
  font-size: 14px;
  color: #333;
  margin-bottom: 16px;
  white-space: pre-wrap;
  line-height: 1.6; /* Adjust line spacing */
  text-align: left; /* Change to 'center' or 'right' if needed */
  max-width: 100%;
  padding: 10px; /* Adjust padding for spacing */

  @media (min-width: 768px) {
    max-width: 425px; /* Ensure the content doesn’t exceed this width */
  }
`;


const PostImage = styled.img`
  width: 100%;
  height : auto;
  max-height: 300px; /* Fixed height */
  // max-width: 100%; /* Ensure the image does not exceed container width */
  object-fit: contain; /* Maintain aspect ratio and fit the entire image within */
  border-radius: 20px;
  margin-bottom: 16px;
  // background: #f1f1f1;
  // box-shadow: 3px 3px 4px #a3b1c6, -5px -5px 15px #ffffff;
  cursor: pointer;
`;


const Actions = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ActionButton = styled.button`
  font-size: 18px;
  color: #e75b82;
  cursor: pointer;
  width : 50%;
  border: none;
  background: #F1F1F1;
  padding: 10px 20px;
  border-radius: 20px;
  margin-right:10px;
  box-shadow: 3px 3px 4px #a3b1c6, -5px -5px 15px #ffffff;
  transition: background 0.2s, box-shadow 0.2s;

  &:hover {
    background: #d4d9e1;
    box-shadow: inset 4px 4px 8px #a3b1c6, inset -4px -4px 8px #ffffff;
  }
`;

// const ReactionContainer = styled.div`
//   display: flex;
//   align-items: center;
//   margin-bottom: 16px;
// `;

// const ReactionIcon = styled.div`
//   display: flex;
//   align-items: center;
//   margin-right: 10px;
//   font-size: 16px;
//   color: #e75b82;

//   & > svg {
//     margin-right: 5px;
//   }
// `;

const CommentInput = styled.input`
  width: 70%;
  padding: 12px;
  border-radius: 20px;
  border: none;
  background: #F1F1F1;
  box-shadow: inset 4px 4px 8px #a3b1c6, inset -4px -4px 8px #ffffff;
  box-sizing: border-box;
  margin: 10px;
  margin-right : 5px;
`;

const ModalButton = styled.button`
  background-color: #e75b82;
  color: #fff;
  padding: 10px 20px;
  margin-top: 15px;
  margin-left: 5px;
  border-radius: 20px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
  box-shadow: 3px 3px 4px #a3b1c6, -5px -5px 15px #ffffff;

  &:hover {
    background-color: #d0456c;
    box-shadow: inset 4px 4px 8px #a3b1c6, inset -4px -4px 8px #ffffff;
  }
`;

const CommentContainer = styled.div`
  border-left: 4px solid #e75b82;
  background-color: #f9f9f9;
  padding: 10px;
  margin-top:5px;
  margin-bottom: 5px;
  border-radius: 20px;
  box-shadow: 4px 4px 8px #a3b1c6, -4px -4px 8px #ffffff;
`;

const ReplyContainer = styled.div`
  border-left: 4px solid #e75b82;
  width : 85%;
  background-color: #f9f9f9;
  padding: 10px;
  margin : 5px;
  margin-left:30px;
  border-radius: 20px;
  box-shadow: 4px 4px 8px #a3b1c6, -4px -4px 8px #ffffff;

  @media(max-width:424px){
    margin-left:20px;
  }
`;

const CommentHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const CharCount = styled.div`
  font-size: 16px;
  color: #888;
  margin:25px 5px 5px 5px;
`;

const CommentProfileImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
  background: #e0e5ec;
  box-shadow: inset 4px 4px 8px #a3b1c6, inset -4px -4px 8px #ffffff;
`;

const CommentUserInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const CommentUserName = styled.span`
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 2px;
  color: #333;
`;

const CommentTime = styled.span`
  color: #666;
  font-size: 12px;
`;

const CommentContent = styled.p`
  font-size: 14px;
  color: #333;
  margin: 0;
`;

const TrashIcon = styled(FontAwesomeIcon)`
  position: absolute;
  top: 16px;
  right: 16px;
  font-size: 18px;
  color: #e75b82;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #d0456c;
  }

  @media (max-width: 374px) {
    top : 10px;
    right : 10px;
    font-size: 14px;
  }
`;

const ReplyButton = styled.button`
  font-size: 16px;
  color: #e75b82;
  background: none;
  border: none;
  cursor: pointer;
  // margin-top: 5px;
  padding: 0;
`;

// const CommentReplyContainer = styled.div`
//   margin-left: 20px;
// `;

// const ReplyInput = styled.textarea`
//   margin-top: 10px;
//   width: 100%;
//   padding: 10px;
//   border: 1px solid #ddd;
//   border-radius: 5px;
//   font-size: 14px;
// `;

const defaultProfileImage = "/images/profile.png"; // Default profile image URL
const defaultCommentProfileImage = "/images/profile.png"; // Default comment profile image URL

const getElapsedTime = (postDate) => {
  const secondsElapsed = Math.floor((new Date() - postDate) / 1000);
  const minutesElapsed = Math.floor(secondsElapsed / 60);
  const hoursElapsed = Math.floor(minutesElapsed / 60);
  const daysElapsed = Math.floor(hoursElapsed / 24);
  const monthsElapsed = Math.floor(daysElapsed / 30);
  const yearsElapsed = Math.floor(monthsElapsed / 12);

  if (secondsElapsed < 60) {
    return `${secondsElapsed} second${secondsElapsed !== 1 ? 's' : ''} ago`;
  } else if (minutesElapsed < 60) {
    return `${minutesElapsed} minute${minutesElapsed !== 1 ? 's' : ''} ago`;
  } else if (hoursElapsed < 24) {
    return `${hoursElapsed} hour${hoursElapsed !== 1 ? 's' : ''} ago`;
  } else if (daysElapsed < 30) {
    return `${daysElapsed} day${daysElapsed !== 1 ? 's' : ''} ago`;
  } else if (monthsElapsed < 12) {
    return `${monthsElapsed} month${monthsElapsed !== 1 ? 's' : ''} ago`;
  } else {
    return `${yearsElapsed} year${yearsElapsed !== 1 ? 's' : ''} ago`;
  }
};


const Post = ({
  userName,
  categoryName,
  postTime,
  content,
  images,
  postKey,
  totalComments,
  totalReactions,
  reactions,
  profileImage,
  setShowLoginModal,
  activeCategory,
  onDeletePost,
}) => {
  const [showCommentInput, setShowCommentInput] = useState(false);
  const [comment, setComment] = useState("");
  const [reply, setReply] = useState("");
  const [comments, setComments] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [totalcomments, setTotalComments] = useState(totalComments);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [imageModalUrl, setImageModalUrl] = useState(null);
  const [replyToComment, setReplyToComment] = useState(null);
  const commentButtonRef = useRef();
  const commentInputRef = useRef();
  const modalButtonRef = useRef();

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsAuthenticated(!!token);
  }, []);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        commentButtonRef.current &&
        !commentButtonRef.current.contains(e.target) &&
        commentInputRef.current &&
        !commentInputRef.current.contains(e.target) &&
        modalButtonRef.current &&
        !modalButtonRef.current.contains(e.target) &&
        lastCommentElementRef.current &&
        !lastCommentElementRef.current.contains(e.target) &&
        showCommentInput
      ) {
        setShowCommentInput(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [showCommentInput]);

  const postDate = new Date(postTime);
  const elapsedTime = getElapsedTime(postDate);

  const handleDeletePost = async () => {
    if (!isAuthenticated) {
      setShowLoginModal(true);
      return;
    }
    const token = localStorage.getItem("token");
    setLoading(true);
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/community-posts/${postKey}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLoading(false);
      NotificationManager.success("Post deleted successfully!", "Success");
      onDeletePost(postKey); // Call the parent callback to remove the post from the list
    } catch (error) {
      setLoading(false);
      NotificationManager.error(
        "Failed to delete post! Please try again!",
        "Error"
      );
      console.error("Error deleting post:", error);
    }
  };

  const fetchComments = async (pageNum) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/community-posts/${postKey}/comments?page=${pageNum}`
      );
      const data = response.data;
      if (data.data)
        setComments((prevComments) => [...prevComments, ...data.data]);
      setHasMore(data.pagination.last_page > pageNum);
      setPage((prevPage) => prevPage + 1);
    } catch (error) {
      NotificationManager.error(
        "Error fetching comments! Please try again!",
        "Error"
      );
      // console.error("Error fetching comments:", error);
    }
    setLoading(false);
  };

  // useEffect(() => {
  //   setPage(1);
  //   setComments([]);
  //   fetchComments(1);
  // }, [postKey]);

  const toggleCommentInput = () => {
    setShowCommentInput(!showCommentInput);
    if (!showCommentInput) {
      setPage(1);
      setComments([]);
      fetchComments(1);
    }
  };

  const handleImageClick = (imageUrl) => {
    setImageModalUrl(imageUrl);
    setShowImageModal(true);
  };  


  const handleCommentChange = (e) => {
    setComment(e.target.value);
  };

  const handleReplyChange = (e) => {
    setReply(e.target.value);
  };

  const handleCommentSubmit = async () => {
    if (!isAuthenticated) {
      setShowLoginModal(true);
      return;
    }
    if (comment.trim().length === 0) {
      NotificationManager.warning(
        "Comment must contain atleast one character!",
        "Warning"
      );
      return;
    }
    const token = localStorage.getItem("token");
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/community-comments`,
        {
          post_key: postKey,
          content: comment,
          parent_comment_key: replyToComment, 
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.status === 200) {
        NotificationManager.success("Commented successfully!", "Success");
        setTotalComments((prevCount) => prevCount + 1);
        setComment("");
        // setShowCommentInput(false);
        setPage(1);
        setReplyToComment(null); 
        setComments([]);
        fetchComments(1);
      } else {
        NotificationManager.error(response.data.message, "Error");
        // alert("Failed to post comment");
      }
    } catch (error) {
      console.error("Error posting comment:", error);
    }
    setLoading(false);
  };

  const handleReplySubmit = async () => {
    if (!isAuthenticated) {
      setShowLoginModal(true);
      return;
    }
    if (reply.trim().length === 0) {
      NotificationManager.warning(
        "Comment must contain atleast one character!",
        "Warning"
      );
      return;
    }
    const token = localStorage.getItem("token");
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/community-comments`,
        {
          post_key: postKey,
          content: reply,
          parent_id: replyToComment, 
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.status === 200) {
        NotificationManager.success("Commented successfully!", "Success");
        setTotalComments((prevCount) => prevCount + 1);
        setReply("");
        // setShowCommentInput(false);
        setPage(1);
        setReplyToComment(null); 
        setComments([]);
        fetchComments(1);
      } else {
        NotificationManager.error(response.data.message, "Error");
        // alert("Failed to post comment");
      }
    } catch (error) {
      console.error("Error posting comment:", error);
    }
    setLoading(false);
  };

  const lastCommentElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (node) {
        const observer = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting && hasMore) {
            fetchComments(page);
          }
        });
        observer.observe(node);
        return () => {
          observer.disconnect();
        };
      }
    },
    [loading, hasMore, page]
  );

  const [showShareOptions, setShowShareOptions] = useState(false);

  const handleShareButtonClick = () => {
    setShowShareOptions(true); // Show the share modal
  };

  const handleCloseShareModal = () => {
    setShowShareOptions(false); // Hide the share modal
  };

  const handleReplyClick = (commentKey) => {
    setReplyToComment(commentKey); // Set the comment to reply to
    setShowCommentInput(true);
  };

  const truncatedUsername = (userName ) => {
    const maxLength = 20;
    const truncatedName = userName.length > maxLength 
      ? `${userName.substring(0, maxLength)}...` 
      : userName;
  
    return (
      <>
        {truncatedName}
      </>
    );
  };

  return (
    <Container>
      {loading && (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      )}
      {activeCategory === "my-posts" && (
        <TrashIcon
          icon={faTrash}
          onClick={() => setShowDeleteConfirmation(true)}
        /> // onClick={handleDeletePost}
      )}
      <CategoryLabel>{categoryName}</CategoryLabel> 
      <Header>
        <ProfileImage src={profileImage || defaultProfileImage} alt="Profile" />
        <UserInfo>
          <UserName>{truncatedUsername(userName)}</UserName>
          <PostTime>{elapsedTime}</PostTime>
        </UserInfo>
      </Header>
      {images &&
        images.map((url, index) => (
          <PostImage key={index} src={url} alt="Post" onClick={() => handleImageClick(url)}/>
        ))}
      <Content>{content}</Content>
      <Actions>
        <ActionButton style={{padding:0}}>
          <LikeButton
            postKey={postKey}
            reactions={reactions}
            totalReactions={totalReactions}
            setShowLoginModal={setShowLoginModal}
          />
        </ActionButton>
        <ActionButton ref={commentButtonRef} onClick={toggleCommentInput}>
          <FontAwesomeIcon icon={faComment} style={{ marginRight: "5px" }} />
          {totalcomments}
        </ActionButton>
        {/* <ActionButton onClick={handleShareButtonClick}>
          <FontAwesomeIcon icon={faShare} style={{ marginRight: "5px" }} />
          Share
        </ActionButton> */}
      </Actions>
      {showCommentInput && (
        <>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            <CommentInput
              ref={commentInputRef}
              type="text"
              placeholder="Write a comment..."
              value={comment}
              onChange={handleCommentChange}
              maxLength={1500}
            />
            <CharCount>{comment.length} / 1500</CharCount>
            <ModalButton ref={modalButtonRef} onClick={handleCommentSubmit} style={{marginLeft:"0"}}>
              <IoSend />
            </ModalButton>
          </div>
          <div>
            {comments.map((comment, index) => {
              const commentDate = new Date(comment.created_at);
              const commentElapsedTime = getElapsedTime(commentDate);

              return (
                <>
                <CommentContainer
                  ref={
                    comments.length === index + 1 ? lastCommentElementRef : null
                  }
                  key={comment.comment_key}
                >
                  <CommentHeader>
                    <CommentProfileImage
                      src={comment.profile_image || defaultCommentProfileImage}
                      alt="Profile"
                    />
                    <CommentUserInfo>
                      <CommentUserName>{truncatedUsername(comment.username)}</CommentUserName>
                      <CommentTime>{commentElapsedTime}</CommentTime>
                    </CommentUserInfo>
                  </CommentHeader>
                  <CommentContent>{comment.content}</CommentContent>
                  <div style={{display:"flex", marginRight:"5px"}}>
                  <LikeCommentModal commentKey={comment.comment_key} totalReactions={comment.totalReactions} setShowLoginModal={setShowLoginModal}>Like</LikeCommentModal>
                  <ReplyButton onClick={() => handleReplyClick(comment.comment_key)}>Reply</ReplyButton>
                  </div>
            {replyToComment === comment.comment_key && (
              <>
                <CommentInput
              ref={commentInputRef}
              type="text"
              placeholder="Write a comment..."
              value={reply}
              onChange={handleReplyChange}
              maxLength={1500}
            />
            {/* <CharCount>{reply.length} / 1500</CharCount> */}
            <ModalButton ref={modalButtonRef} onClick={handleReplySubmit} style={{marginLeft:"0"}}>
              <IoSend />
            </ModalButton>
              </>
            )}
                  {comment.children && comment.children.length > 0 && (
                    comment.children.map((childComment,index)=>{
                      const commentDate = new Date(childComment.created_at);
                      const commentElapsedTime = getElapsedTime(commentDate);

                    return (
                      <>
                      <ReplyContainer
                      ref={
                        childComment.length === index + 1 ? lastCommentElementRef : null
                      }
                      key={childComment.comment_key}
                    >
                      <CommentHeader>
                        <CommentProfileImage
                          src={childComment.profile_image || defaultCommentProfileImage}
                          alt="Profile"
                        />
                        <CommentUserInfo>
                          <CommentUserName>{childComment.username}</CommentUserName>
                          <CommentTime>{commentElapsedTime}</CommentTime>
                        </CommentUserInfo>
                      </CommentHeader>
                      <CommentContent>{childComment.content}</CommentContent>
                    <LikeCommentModal commentKey={childComment.comment_key} totalReactions={childComment.totalReactions} setShowLoginModal={setShowLoginModal}>Like</LikeCommentModal>
                    </ReplyContainer>
                    </>
                    )})
                  )}
                </CommentContainer>
                </>
              );
            })}
            {loading && <p>Loading more comments...</p>}
          </div>
        </>
      )}
      <ShareModal show={showShareOptions} onClose={handleCloseShareModal} postKey={postKey}/>
      <DeleteConfirmationModal
        show={showDeleteConfirmation}
        onClose={() => setShowDeleteConfirmation(false)}
        onConfirm={handleDeletePost}
      />
      {showImageModal && (
        <ImageModal
          imageUrl={imageModalUrl}
          onClose={() => setShowImageModal(false)}
        />
      )}
      <NotificationContainer />
    </Container>
  );
};

export default Post;
